import React from 'react';
import { Form, Input, Space, Button, Select, Popconfirm } from 'antd';
import ItemContent from './ItemContent';
import DateRangePicker from '../DateRangePicker';

import { useGetHolidays } from 'hooks/product-price/base/getHolidays';

interface PropsType {
  value?: any;
  onChange?: any;
  enums?: any;
}

const DEGAULT_FIELDS = [{}]

const TemplateSelect:React.FC<PropsType> = (props) => {
  const { enums } = props || {};
  const { f_rule_days_limit } = enums || {};

  const { holidayEnum } = useGetHolidays();

  const form = Form.useFormInstance();

  const handleRangeSet = (item: any, subOpt: any) => {
    const rangeInfo = form.getFieldValue('rental_day_limit');
    if (!rangeInfo[(rangeInfo || []).length - 1]) {
      rangeInfo[(rangeInfo || []).length - 1] = {};
    }
    rangeInfo[(rangeInfo || []).length - 1].date_ranges = item.date_ranges;
    form.setFieldValue('rental_day_limit', rangeInfo);
  }

  return (
    <>
      <Form.Item
        label="模板名称"
        name="name"
        labelCol={{ span: 3 }}
        rules={[{ required: true, message: "请输入模板名称" }]}
      >
        <Input placeholder="请输入模板名称" />
      </Form.Item>
      <Form.Item label="起租时间" style={{ marginTop: '60px' }} labelCol={{ span: 3 }}>
        <Form.List name="rental_day_limit" initialValue={DEGAULT_FIELDS}>
          {(subFields, subOpt) => (
            <div style={{ display: 'flex', flexDirection: 'column', rowGap: 16 }}>
              <div>
                <Button type="dashed" onClick={() => subOpt.add()}>
                  添加时段
                </Button>
                {(holidayEnum || []).map((item: any) => {
                  return (
                    <Button style={{ marginLeft: '12px' }} type="dashed" onClick={() => { subOpt.add(); handleRangeSet(item, subOpt)}}>
                      {item.name}
                    </Button>
                  )
                })}
              </div>

              {subFields.map((subField) => (
                <Space key={subField.key}>
                  取车或还车时间在
                  <Form.Item noStyle name={[subField.name, 'date_ranges']} rules={[{ required: true, message: "" }]}>
                    <DateRangePicker previousDisabled />
                  </Form.Item>
                  内
                  <Form.Item noStyle name={[subField.name, 'limit']} rules={[{ required: true, message: "" }]}>
                    <Select
                      style={{ width: 120 }}
                      options={((f_rule_days_limit || []).map((item: any) => ({ label: item.value, value: item.key })))}
                    />
                  </Form.Item>
                  天起租
                  {subFields.length > 1 && <Popconfirm
                    title="请确认删除对应起租日设置?"
                    onConfirm={() => {
                      subOpt.remove(subField.name);
                    }}
                    okText="确认"
                    cancelText="取消"
                  >
                    <Button danger>删除</Button>
                  </Popconfirm>}
                </Space>
              ))}
            </div>
          )}
        </Form.List>
      </Form.Item>
      <Form.Item
        style={{ marginTop: '60px' }}
        label="零散小时租金"
        name="gt_several_hour"
        labelCol={{ span: 3 }}
      >
        <ItemContent enums={enums} />
      </Form.Item>
    </>
  )
}

export default TemplateSelect;